import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BlockContents" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_ParagraphFullhtml = _resolveComponent("ParagraphFullhtml")!
  const _component_ParagraphHeading = _resolveComponent("ParagraphHeading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingContent, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : (_ctx.element_type === 'paragraph--full_html')
        ? (_openBlock(), _createBlock(_component_ParagraphFullhtml, {
            key: 2,
            cms_response: _ctx.CMS_response
          }, null, 8, ["cms_response"]))
        : (_ctx.element_type === 'paragraph--heading')
          ? (_openBlock(), _createBlock(_component_ParagraphHeading, {
              key: 3,
              cms_response: _ctx.CMS_response
            }, null, 8, ["cms_response"]))
          : _createCommentVNode("", true)
  ]))
}